import { useNavigate } from "react-router-dom";
import CardAccount from "./CardAccount";
import { useState, useEffect } from "react";
import SVG from "../../../Components/SVG";
import { API_BASE_URL } from "../../../config/api";

export default function ChooseAccount() {
  const navigate = useNavigate();
  const [accountData, setAccountData] = useState(null);
  const [userData, setUserData] = useState(null);
  const fetchAccountData = async () => {
    try {
      let response = await fetch(`${API_BASE_URL}challenges/trader/accounts`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      });

      // 401 → try refresh
      if (response.status === 401) {
        try {
          const refreshResponse = await fetch(
            `${API_BASE_URL}auth/trader/jwt/refresh/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                refresh: localStorage.getItem("refresh"),
              }),
            },
          );

          if (!refreshResponse.ok) {
            // refresh failed → logout and redirect
            localStorage.removeItem("access");
            localStorage.removeItem("authCredentials");
            localStorage.removeItem("refresh");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            navigate("/signin");
            return;
          }

          const refreshData = await refreshResponse.json();
          localStorage.setItem("access", refreshData.access);

          // retry original request with new token
          response = await fetch(`${API_BASE_URL}challenges/trader/accounts`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          });
        } catch (err) {
          console.error("Error refreshing token:", err);
          return;
        }
      }

      // final check
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setAccountData(data);
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  const fetchUserData = async () => {
    try {
      let response = await fetch(`${API_BASE_URL}auth/trader/info/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      });

      // 401 → try refresh
      if (response.status === 401) {
        try {
          const refreshResponse = await fetch(
            `${API_BASE_URL}auth/trader/jwt/refresh/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                refresh: localStorage.getItem("refresh"),
              }),
            },
          );

          if (!refreshResponse.ok) {
            // refresh failed → logout and redirect
            localStorage.removeItem("access");
            localStorage.removeItem("authCredentials");
            localStorage.removeItem("refresh");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            navigate("/signin");
            return;
          }

          const refreshData = await refreshResponse.json();
          localStorage.setItem("access", refreshData.access);

          // retry original request with new token
          response = await fetch(`${API_BASE_URL}auth/trader/info/`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          });
        } catch (err) {
          console.error("Error refreshing token:", err);
          return;
        }
      }

      // final check
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("User Data:", data);
      setUserData(data);
      localStorage.setItem("fn", data?.fn);
      localStorage.setItem("ln", data?.ln);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (accountData && accountData?.live?.length === 0) {
      setIsLoading(false);
    }
  });

  useEffect(() => {
    fetchAccountData();
    fetchUserData();
  }, []);
  return (
    <div className="w-full flex-1 min-h-0 bg-zi-bg2-light dark:bg-zi-bg2-dark rounded-2xl p-5 flex flex-col gap-10 items-center justify-start relative">
      <h3 className="w-full text-start text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
        لیست حساب‌های فعال
      </h3>
      <div className="w-full flex-1 min-h-0 grid lg:grid-cols-2  justify-items-center gap-x-10 gap-y-20 pb-0.5 overflow-auto">
        {accountData &&
          accountData.live &&
          accountData.live.map((item) => (
            <CardAccount
              key={item.id}
              account={item}
              user={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          ))}
        {isLoading && (
          <div className="w-full px-5 flex-1 grid lg:grid-cols-2  justify-items-center gap-x-10 gap-y-20 pb-0.5 overflow-auto absolute top-[88px] left-1/2 -translate-x-1/2">
            <div className="w-full max-w-96 flex flex-col gap-3">
              <div className="w-full aspect-[388/246] rounded-3xl skeleton"></div>
              <div className="flex gap-8">
                <div className="w-full rounded-full h-[46px] skeleton"></div>
                <div className="w-full rounded-full h-[46px] skeleton"></div>
              </div>
            </div>
            <div className="w-full max-w-96 hidden lg:flex flex-col gap-3">
              <div className="w-full aspect-[388/246] rounded-3xl skeleton"></div>
              <div className="flex gap-8">
                <div className="w-full rounded-full h-[46px] skeleton"></div>
                <div className="w-full rounded-full h-[46px] skeleton"></div>
              </div>
            </div>
          </div>
        )}
        {accountData && accountData.live && accountData?.live?.length === 0 && (
          <div className="absolute top-[116px] left-1/2 -translate-x-1/2 flex flex-col justify-center items-center gap-6 w-full">
            <p className="py-2.5 w-11/12 max-w-xs rounded-lg text-center text-lg font-light text-zi-text-light dark:text-zi-text-dark">
              حساب فعال ندارید
            </p>
            <SVG name="noAccount" classname="w-1/3 max-w-40" />
          </div>
        )}
      </div>
    </div>
  );
}
